import type { OrderDirectionType } from '../types';

import { reportOrderTooltip, DEFAULT_TOOLTIP } from '../constants';
export const getOrderTooltip = (field: string, direction: OrderDirectionType) => {
  if (!reportOrderTooltip[field]) return DEFAULT_TOOLTIP[direction];

  return reportOrderTooltip[field][direction];
};
